import { Splide } from "@splidejs/splide";

const carousel = () => {
  const parentElms = document.getElementsByClassName('js-sliderStory');
  if(parentElms.length === 0) return;

  for(const parentElm of parentElms) {
    const speed = 800;
    // 既に初期化済みかチェック
    if(parentElm.dataset.initialized === 'true') {
      continue;
    }
    // 親スライダーのオプション
    let parentOptions = {
      type: "fade",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      // gap: "0.5rem",
      // direction: 'ttb',
      // heightRatio: 1.09375,
      heightRatio: 1.4,
      arrows: false,
      pagination: false,
      wheel: true,
      waitForTransition: true,
      wheelSleep: 1000,
      releaseWheel: true,
      breakpoints: {
        768: {
          drag: false,
          swipe: false,
          wheel: false,
          waitForTransition: false,
          heightRatio: 1.85,
        },
        576: {
          drag: false,
          swipe: false,
          wheel: false,
          waitForTransition: false,
          heightRatio: 1.9,
        },
      },
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
        autoplay: true,
      }
    }
    
    // data属性からオプションを上書き
    if(parentElm.dataset.speed) {
      const customSpeed = parseInt(parentElm.dataset.speed);
      parentOptions.speed = customSpeed;
      parentOptions.rewindSpeed = customSpeed;
      parentOptions.reduceMotion.speed = customSpeed;
      parentOptions.reduceMotion.rewindSpeed = customSpeed;
    }

    if(parentElm.dataset.gap) {
      parentOptions.gap = parentElm.dataset.gap;
    }

    // 親スライダーを作成
    const parentSlider = new Splide(parentElm, parentOptions);
    
    // ===================================
    // 子スライダーの初期化
    // ===================================
    const childSlidersInParent = parentElm.querySelectorAll('.js-sliderStorySub');
    const childSliders = [];
    
    childSlidersInParent.forEach((childElm, index) => {
      // 既に初期化済みかチェック
      if(childElm.dataset.initialized === 'true') {
        return;
      }
      
      let childOptions = {
        type: "fade",
        speed: speed,
        rewindSpeed: speed,
        perPage: 1,
        perMove: 1,
        // gap: "0.3rem",
        arrows: false,
        speed: 1000,
        pagination: true,
        autoplay: true,
        interval: 3000,
        focus: 'center',
        trimSpace: false,
        // rewind: true,
        reduceMotion: {
          speed: speed,
          rewindSpeed: speed,
        }
      }
      
      // 子スライダー固有のdata属性があれば上書き
      if(childElm.dataset.speed) {
        const customSpeed = parseInt(childElm.dataset.speed);
        childOptions.speed = customSpeed;
        childOptions.rewindSpeed = customSpeed;
        childOptions.reduceMotion.speed = customSpeed;
        childOptions.reduceMotion.rewindSpeed = customSpeed;
      }

      if(childElm.dataset.gap) {
        childOptions.gap = childElm.dataset.gap;
      }

      // autoWidthを使いたい場合の設定
      if(childElm.dataset.autowidth === 'true') {
        delete childOptions.perPage;
        childOptions.autoWidth = true;
        childOptions.focus = 0;
      }
      
      const childSlider = new Splide(childElm, childOptions);
      // 初期化済みマークを付ける
      childElm.dataset.initialized = 'true';
      childSliders.push(childSlider);
    });
    
    // ===================================
    // カスタムページネーションの設定（複数対応）
    // ===================================
    // data-pagination属性からカンマ区切りで複数のIDを取得
    const paginationIds = parentElm.dataset.pagination;
    
    if(paginationIds) {
      // カンマで区切って配列に変換（前後の空白も除去）
      const paginationIdArray = paginationIds.split(',').map(id => id.trim());
      
      // すべてのカスタムページネーション要素を格納する配列
      const allCustomPaginations = [];
      
      // 各IDに対応するページネーション要素を取得
      paginationIdArray.forEach(paginationId => {
        const customPagination = document.getElementById(paginationId);
        if(customPagination) {
          allCustomPaginations.push(customPagination);
        }
      });
      
      // ページネーション要素が1つでも見つかった場合
      if(allCustomPaginations.length > 0) {
        // すべてのページネーションのボタンを格納する配列
        const allPaginationButtons = [];
        
        // 各ページネーション要素のボタンを取得してイベントを設定
        allCustomPaginations.forEach(customPagination => {
          const paginationButtons = customPagination.querySelectorAll('.js-pagination-item');
          
          if(paginationButtons.length > 0) {
            // 初期状態: 最初のボタンをアクティブに
            paginationButtons[0]?.classList.add('is-active');
            
            // 各ボタンにクリックイベントを追加
            paginationButtons.forEach((button, index) => {
              // 既存のイベントリスナーを削除するため、新しい要素に置き換える
              const newButton = button.cloneNode(true);
              button.parentNode.replaceChild(newButton, button);
              
              newButton.addEventListener('click', () => {
                parentSlider.go(index);
              });
              
              // すべてのボタンの配列に追加
              allPaginationButtons.push(newButton);
            });
          }
        });
        
        // スライダーが移動したときにすべてのページネーションのアクティブ状態を更新
        parentSlider.on('move', (newIndex) => {
          // すべてのボタンからis-activeを削除
          allPaginationButtons.forEach(btn => {
            btn.classList.remove('is-active');
          });
          
          // 各ページネーションの対応するボタンにis-activeを追加
          allCustomPaginations.forEach(customPagination => {
            const buttons = customPagination.querySelectorAll('.js-pagination-item');
            if(buttons[newIndex]) {
              buttons[newIndex].classList.add('is-active');
            }
          });
          
          // 新しいスライドの子スライダーを最初の位置に戻す
          if(childSliders[newIndex]) {
            childSliders[newIndex].go(0);
          }
        });
        
        // マウント時にもアクティブ状態を確認
        parentSlider.on('mounted', () => {
          const currentIndex = parentSlider.index;
          
          allCustomPaginations.forEach(customPagination => {
            const buttons = customPagination.querySelectorAll('.js-pagination-item');
            buttons.forEach((btn, index) => {
              if(index === currentIndex) {
                btn.classList.add('is-active');
              } else {
                btn.classList.remove('is-active');
              }
            });
          });
        });
      }
    }
    
    // ===================================
    // マウント処理
    // ===================================
    // 親スライダーをマウント
    parentSlider.mount();
    
    // 子スライダーを順番にマウント
    childSliders.forEach((slider) => {
      slider.mount();
    });
    // または、カスタムホイールイベントを実装する場合
    let isScrolling = false;

    parentSlider.on('move', () => {
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 300);
    });

    window.addEventListener('wheel', (e) => {
      const isAtEnd = parentSlider.index === parentSlider.length - 1;
      
      // 最後のスライドで下スクロールの場合、通常のスクロールを許可
      if (isAtEnd && e.deltaY > 0 && !isScrolling) {
        // Splideのホイールイベントを無効化
        return true;
      }
    }, { passive: true });
        // 初期化済みマークを付ける
        parentElm.dataset.initialized = 'true';
      }
    }

const init = () => {
  carousel();
}

// 初期化
init();

export default init;